angular.module('impactx.invoice').directive('ixInvoiceComplaintsList', function ()
{
    return {
        scope: {
            trns: "=",
            list: "=",
            shownComplaintsControls: "=",
            deleteConditionFunc: "&",
            deleteItem: "&"
        },
        restrict: 'E',
        templateUrl: 'modules/invoice/templates/invoice-complaints-list.html',
        controller: function ($scope) {
            this.deleteItem = function (event, iciId) {
                if ($scope.deleteItem) {
                    $scope.deleteItem({event: event, iciId: iciId});
                }
            }
        },
        controllerAs: '$ctrl'
    };
});